import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.accountCertificate.replace(appPath.account, ''),
	components: () => [import(/* webpackChunkName: 'accountCertificate' */ './component')],
	render: ([MemberOrder]) => <MemberOrder />,
};

export default routes;
